import { CLEAR_DATA, ClearDataAction } from './types';

export const clearData = (): ClearDataAction => ({
  type: CLEAR_DATA,
});

export default {
  clearData,
};
